import { useCallback, useState } from 'react';

// ----------------------------------------------------------------------

export type UseSeatCountReturn = {
  seatCount: number;
  onChangeSeatCount: (newValue: number) => void;
  /********/
  open: boolean;
  onOpen?: () => void;
  onClose: () => void;
  onReset?: () => void;
  /********/
  setSeatCount?: React.Dispatch<React.SetStateAction<number>>;
};

export function useSeatCount(): UseSeatCountReturn {
  const [open, setOpen] = useState(false);

  const [seatCount, setSeatCount] = useState(1);

  const onOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);

  const onChangeSeatCount = useCallback((newValue: number) => {
    setSeatCount(newValue);
  }, []);

  const onReset = useCallback(() => {
    setSeatCount(1);
  }, []);

  return {
    seatCount: seatCount as number,
    onChangeSeatCount,
    /********/
    open,
    onOpen,
    onClose,
    onReset,
    /********/
    setSeatCount,
  };
}
